import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_2xl,
  font_size_md,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.OrgSettingsReceiptVerificationBox {
    .heading-row {
      display: flex;
      align-items: center;
      gap: ${spacing(2)};
      margin-bottom: ${spacing(4)};
    }

    .heading-text {
      font-family: ${font_family_weight_medium};
      font-size: ${font_size_2xl};
      color: ${text_colorTextPrimary};
    }

    .body-text {
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_sm};
      color: ${text_colorTextSecondary};
      margin-bottom: ${spacing(10)};
    }

    .switch-label {
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_md};
      color: ${text_colorTextSecondary};
      margin-bottom: ${spacing(2)};
    }

    .switch-container {
      display: flex;
      width: 175px;
    }

    .error-message {
      margin-top: ${spacing(2)};
      padding-left: 0;
    }
  }
`
